// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"385de427","135":"0060b82b","630":"6024aedd","700":"201ad25d","777":"978fe4b0","779":"e750f2e1","875":"b37fad64","973":"d408a393"}[chunkId] + ".chunk.js";
};